import { IElement, IDeleteSetName } from 'routes/private/Editor/types';

export const removeElementResolver = (parentElement: IElement, elementToRemove: IElement, commandChangeValue: IDeleteSetName): IElement => {
  if (parentElement.children) {
    const index = parentElement.children.map((child)=>{return child.id}).indexOf(elementToRemove.id);
    if (index !== -1) {
      parentElement.children?.splice(index,1);
    }    
    if (commandChangeValue && commandChangeValue.selectedSetName)
    {
      if (commandChangeValue.selectedSetName === elementToRemove.name && commandChangeValue.setNames.length) {
        let index = commandChangeValue.setNames.findIndex(s => s === elementToRemove.name);
        if (commandChangeValue.setNames[index + 1]) index++;
        else index--;
        const newSelectedSet = commandChangeValue.setNames[index];
        parentElement.children?.forEach(element => {
          element.attributes.hidden = element.name === newSelectedSet ? false : true;
          return element;
        })
      }
    }
  }
  return parentElement;
}